module.exports = __webpack_public_path__ + "static/media/3. Finished.d6871fc4.svg";